import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';

import { httpOptions } from '../shared/config/config-app';
import { environment } from 'src/environments/environment';
import { Pessoa } from '../shared/models/shared-model/pessoa.model';
import { SharedService } from './../shared/services/shared.service';
import { Usuario } from '../shared/models/shared-model/usuario.model';
import { TokenAuthorization } from "../shared/models/shared-model/token-authorization.model";
import { ResponseUsuario } from "../shared/models/shared-model/response-usuario.model";

@Injectable()
export class LoginService {

  usuario: Usuario;

  constructor(private httpClient: HttpClient,
              private cookieService: CookieService,
              private sharedService: SharedService) {}

  /**
   * @method login
   * @description Verifica dados username e password e efetua login
   * @param usuario Objeto Usuario
   */
  login(usuario: Usuario): Observable<Usuario> {
    return this.httpClient.post<Usuario>(environment.login, usuario);
  }

  /**
   * @method userIsLoggedIn
   * @description Verifica os cookies e retorna se o usuario esta logado
   */
  userIsLoggedIn(): boolean {
    if (this.cookieService.get('siriema.id') && this.cookieService.get('siriema.data')
        && localStorage.getItem('access_token') !== null) {
      return true;
    }
    return false;
  }

  /**
   * @method saveSession
   * @description Salva os dados de sessao nos cookies
   * @param usuario Objeto Usuario
   */
  saveSession(usuario: Usuario): void {
    if (usuario !== null && usuario !== undefined) {
      this.cookieService.deleteAll();
      this.cookieService.set('siriema.id', usuario.id.toString(), null);
      this.cookieService.set('siriema.data', JSON.stringify(usuario), null);
    }  
  }

    /**
   * @method saveSessionPessoa
   * @description Salva os dados de sessao nos cookies
   * @param pessoa Objeto Pessoa
   */
  saveSessionPessoa(pessoa: Pessoa): void {
    if (pessoa !== null && pessoa !== undefined) {
      this.cookieService.deleteAll();
      this.cookieService.set('siriema.id', pessoa.id.toString(), null);
      this.cookieService.set('siriema.data', JSON.stringify(pessoa), null);
    }  
  }

  /**
   * @method logout
   * @description Realiza o logout e limpa os cookies da sessao
   */
  logout() {
    this.cookieService.deleteAll();
  }

  getSexo() {
    return this.sharedService.getSexo();
  }

  getEstadoCivil() {
    return this.sharedService.getEstadoCivil();
  }

  insert(pessoa: Pessoa): Observable<Pessoa> {
    console.log('Pessoa informada a api rest: ' + pessoa.nome);
    return this.httpClient.post<Pessoa>(environment.usuarios.save, pessoa, httpOptions);
  }
  
  private handlerError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getUsuarioLogado(): number {
    return +this.cookieService.get('siriema.id');
  }

  retornaUsuarioLogado(): Pessoa {
    return JSON.parse(this.cookieService.get('siriema.data'));
  }

  getToken(): void {
    this.removeTokenOld();
    this.sharedService.getTokenSGI().subscribe((token: TokenAuthorization) => {
      localStorage.setItem("access_token", token.access_token);     
    });
  }

  setUsuarioSemCadastro(usuarioSemCadastro: Usuario): void {
    this.usuario = usuarioSemCadastro;
  }

  getUsuarioSemCadastro(): Usuario {
    return this.usuario;
  }

  getUsuarioEstrangeiroExisteBD(estrangeiro: string): Promise<ResponseUsuario> {
    const urlEstrangeiro = `${environment.usuarios.getUsuarioEstrangeiro}${estrangeiro}`;
    return this.httpClient.get<ResponseUsuario>(urlEstrangeiro).toPromise();
  }

  getUsuarioBrasileiroExisteBD(brasileiro: string): Promise<ResponseUsuario> {
    const urlBrasileiro = `${environment.usuarios.getUsuarioBrasileiro}${brasileiro}`;
    return this.httpClient.get<ResponseUsuario>(urlBrasileiro).toPromise();
  }

  removeTokenOld(): void {
    localStorage.removeItem("access_token");    
  }

  getManualPdf(): Observable<any> {
    const url = `${environment.manual}`;
    return this.httpClient.get(url, {responseType: 'blob' as 'json'});
  }
}
